import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form'
import Dropzone from 'react-dropzone';
import { renderCal, renderInput, renderCheckbox }from '../newcaso/Fields'
import moment from 'moment'
import {SortableContainer, SortableElement, SortableHandle, arrayMove} from 'react-sortable-hoc';
import AddressesForm from '../AddressForm'
import ModelsList from './ModelsList'
import _ from 'lodash'

const DragHandle = SortableHandle(() => <i className="fa fa-bars handler"></i>);
const SortableItem = SortableElement((props) =>{
    return(
        <li className="list-group-item list-group-item-action noselect">
            <DragHandle />
            {props.value.name}
            <div className="btn-group pull-right">
                <button
                    type="button"
                    className="btn btn-sm btn-outline-warning"
                    onClick={(e) => {
                        e.preventDefault()
                        props.duplicateAction(props.i)
                    }}
                >
                    <i className="fa fa-copy"></i>
                </button>
                <button
                    type="button"
                    className="btn btn-sm btn-outline-danger"
                    onClick={(e) => {
                        e.preventDefault()
                        props.deleteAction(props.i)
                    }}
                >
                    <i className="fa fa-remove"></i>
                </button>
            </div>
        </li>
        )
    }
);

const SortableList = SortableContainer((props) => {
    return(
        <ul className="list-group">
            {props.files.map((value, index) => (
                <SortableItem deleteAction={props.deleteAction} duplicateAction={props.duplicateAction} key={`item-${index}`} index={index} value={value} i={index} />
            ))}
        </ul>
    );
});

class ModelsStep1 extends Component{
    constructor(props) {
        super(props);
        this.state = {
            files: [],
            error: null
        };
    }
    componentDidMount(){
        console.log("test", this.state.files)
        console.log("from parent", this.props.prevFiles)

        if(this.props.prevFiles.length !== -1){
            this.setState({files: this.props.prevFiles})
        }
    }
    duplicateAction(index){
        // let index = this.state.files.indexOf(value)

        this.setState((prevState) => ({
            files: [
                ...prevState.files.slice(0, index),
                prevState.files[index],
                prevState.files[index],
                ...prevState.files.slice(index+1)
            ],
            error: null
        }));
    }
    deleteAction(index){
        // let index = this.state.files.indexOf(value)
        this.setState((prevState) => ({
            files: prevState.files.filter((_, i) => i !== index)
        }));
    }
    onSortEnd = ({oldIndex, newIndex}) => {
        const {files} = this.state;

        this.setState({
            files: arrayMove(files, oldIndex, newIndex),
        });
        console.log(this.state)
    };
    renderField(field){
        return(
            <div className="form-group">
                <label>{field.label}</label>
                <input
                    className="form-control"
                    type={field.type}
                    {...field.input}
                />
            </div>
        )
    }
    renderSelect(field){
        if(_.isEmpty(this.props.casos.data)){
            return(<div className="form-group">loading</div>);
        }
        var options = this.props.casos.data.map((caso) => {
            return(
                <option key={caso.id} value={caso.id}>{caso.title}</option>
            )
        });
        return(
            <div className="form-group">
                <label>{field.label}</label>
                <select
                    className="form-control"
                    {...field.input}
                >
                    {options}
                </select>
            </div>
        )
    }
    renderDropzoneInput(field){
        const files = field.input.value;
        return (
            <div className="dropzone-container">
                {field.meta.touched && field.meta.error && <span className="text-danger">{field.meta.error}</span>}
                <Dropzone
                    className="dropzone"
                    name={field.name}
                    multiple={true}
                    onDrop={( filesToUpload, e ) => {
                        this.setState({files: [...this.state.files, ...filesToUpload], error: null})
                    }}
                >
                    <div>Haz click o arrastra los archivos que deseas incluir.</div>
                </Dropzone>
            </div>
        );
    }
    onSubmit(data){
        let modelsUploadedBefore = this.props.caso
        && this.props.caso.modelos
        && this.props.caso.modelos.length > 0 ? this.props.caso.modelos.length + 1 : 0;
        const order = this.state.files.map((item, index) => {
            return {
                order: index + modelsUploadedBefore,
                name: item.name
            }
        });
        if((order.length + this.props.caso.modelos.length) % 2 !== 0){
            this.setState({ error: "Está intentando subir "+ order.length +" modelos, recuerde que los modelos deben ser pares para su correcta visualizacón en 3D checker. Puede duplicar modelos desde el listado para parearlos." })
            return false
        }
        const post = {
            order: order,
            files: this.state.files
        }
        this.props.nextPage(post)
    }
    render(){
        const { handleSubmit } = this.props;
        return(
            <div>
                <ModelsList />
                <div className="alert alert-info mb-4">Si va a subir más de 30 modelos, por favor hágalo por lotes (un máximo 30 modelos por lote). Recuerde que la pieza mandibular debe estar en primera posición para su correcta visualización en 3Dchecker</div>
                <form onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                    <Field
                        name="files"
                        component={this.renderDropzoneInput.bind(this)}
                    />
                    <SortableList
                        duplicateAction={this.duplicateAction.bind(this)}
                        deleteAction={this.deleteAction.bind(this)}
                        files={this.state.files}
                        onSortEnd={this.onSortEnd}
                        useDragHandle={true}
                    />
                    {this.state.error && <div className="alert alert-danger mt-4">{this.state.error}</div>}
                    <div className="form-actions">
                        <button type="submit" className="btn btn-primary next float-right">
                            IPR / Ataches &nbsp;
                            <i className="fa fa-chevron-right"></i>
                        </button>
                    </div>
                </form>
            </div>
        )
    }
}
export default reduxForm({
    form: 'altamodelos', // <------ same form name
    destroyOnUnmount: false, // <------ preserve form data
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
    // validate,
})(ModelsStep1);


// WEBPACK FOOTER //
// ./resources/assets/js/components/forms/models/ModelsStep1.jsx